import React, { SVGProps } from 'react';

export const PlusSquareSVG = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M0.768065 9.0088C0.896783 10.194 1.84845 11.1456 3.03313 11.2794C4.00656 11.3894 5.00756 11.487 6.02903 11.487C7.0505 11.487 8.05151 11.3894 9.02494 11.2794C10.2096 11.1456 11.1613 10.194 11.29 9.0088C11.3951 8.04062 11.4867 7.0451 11.4867 6.02927C11.4867 5.01344 11.3951 4.01792 11.29 3.04975C11.1613 1.8645 10.2096 0.912962 9.02494 0.779112C8.05151 0.66913 7.0505 0.571533 6.02903 0.571533C5.00756 0.571533 4.00656 0.66913 3.03313 0.779112C1.84845 0.912962 0.896783 1.8645 0.768065 3.04975C0.66292 4.01792 0.571289 5.01344 0.571289 6.02927C0.571289 7.0451 0.66292 8.04062 0.768065 9.0088Z'
      stroke='#252F3F'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M5.23535 14.2603C5.64369 14.7806 6.25152 15.139 6.93947 15.217C7.92406 15.3286 8.93699 15.4285 9.97089 15.4285C11.0048 15.4285 12.0177 15.3286 13.0023 15.217C14.1664 15.085 15.101 14.1505 15.228 12.9859C15.3347 12.0066 15.4287 10.9991 15.4287 9.97083C15.4287 8.94256 15.3347 7.93511 15.228 6.95576C15.1521 6.25995 14.788 5.64627 14.2588 5.23682'
      stroke='#252F3F'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path d='M6.02881 8.75827V3.30054' stroke='#252F3F' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M3.2998 6.0293H8.75755' stroke='#252F3F' strokeLinecap='round' strokeLinejoin='round' />
  </svg>
);
